import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "../../util/DateConvertor";

export class TransactionService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getTransactionListData(
        page,
        size,
        startDate,
        endDate,
        phoneNumber,
        status,
        paymentGatewayId
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "/payment-transactions",
                {
                    page,
                    size,
                    "start-pay-at": startDate && startDate.length === 10 ? convertPersianDateToUniversalDate(startDate) : "",
                    "end-pay-at": endDate && endDate.length === 10 ? convertPersianDateToUniversalDate(endDate) : "",
                    phoneNumber,
                    status: status === "ALL" ? "" : status,
                    "payment-gateway-id": paymentGatewayId && paymentGatewayId > 0 ? paymentGatewayId : null
                }
            ).then(resolve).catch(reject)
        })
    }

    getTransactionInformation(transactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/payment-transactions/${transactionId}/information`
            ).then(resolve).catch(reject)
        })
    }
}